import React, { useState, useEffect } from "react";
import "./admin.css";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import AjouterProjet from "../Admin/ajouterProjet.js";
import SupprimerProjet from "../Admin/deleteProjet.js";

import loadingImage from "../../assets/images/loadinpic.png";
import { API_ROUTES } from "../../utils/constant";

const Admin = () => {
  const [isLoading, setIsLoading] = useState(true);

  const [adminName, setAdminName] = useState("");
  const [currentTime, setCurrentTime] = useState(new Date());
  const [currentDate, setCurrentDate] = useState("");

  const navigate = useNavigate();

  const currentTheme = localStorage.getItem("theme");

  useEffect(() => {
    const projetSelectElement = document.querySelector("admin");

    if (projetSelectElement) {
      if (currentTheme === "light") {
        projetSelectElement.classList.remove("dark-mode-details-admin");
        projetSelectElement.classList.add("light-mode-details-admin");
      } else {
        projetSelectElement.classList.remove("light-mode-details-admin");
        projetSelectElement.classList.add("dark-mode-details-admin");
      }
    }
  }, [currentTheme]);

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token) {
      axios
        .get(API_ROUTES.admin)
        .then((response) => {
          setAdminName(response.data.name);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error(
            "Erreur lors de la récupération du nom de l'administrateur : ",
            error
          );
          setIsLoading(false);
        });
    } else {
      navigate("/connexion");
    }

    // Mettre à jour l'heure toutes les secondes
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
      setCurrentDate(formatDate(new Date()));
    }, 1000);

    // Nettoyer l'intervalle lorsque le composant est démonté
    return () => {
      clearInterval(intervalId);
    };
  }, [navigate]);

  const formatDate = (date) => {
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return date.toLocaleDateString("fr-FR", options);
  };

  return (
    <div className="admin">
      {isLoading ? (
        <div>
          <img src={loadingImage} alt="Loading" className="loading-image" />
          <p>Chargement...</p>
        </div>
      ) : (
        <>
          <div className="informations">
            <h2>Hello {adminName}</h2>
            <p>{currentDate}</p>
            <p>{currentTime.toLocaleTimeString()}</p>
          </div>

          <div className="admin-container">
            <div className="admin-content">
              <AjouterProjet />
              <Link to="/editer/:id">Modifier un projet </Link>
              <SupprimerProjet />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Admin;

 
  
